import "./GenericPartRequestModal.css";
export const GenericPartRequestModal = ({
  title,
  description,
  onClose,
  okAction,
  maxWidth,
  textArea = false,
  confirmLabel = "Ok",
  displayButton = true,
  displayCloseButton = true
}) => {
  const setConditionalNote = (value) => {};
  const handlerOkAction = () => {
    okAction();
    onClose();
  };
  return (
    <section
      className="part-request-modal-container"
      style={{ maxWidth: maxWidth }}
    >
      <div className="part-request-modal-header">
        <h3>{title}</h3>
        {displayCloseButton && 
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>}
      </div>
      <p dangerouslySetInnerHTML={{ __html: description }} />
      {textArea && (
        <textarea onChange={(e) => setConditionalNote(e.target.value)} />
      )}

      <div className="part-request-modal-buttons">
        <button className="pr-ok" onClick={handlerOkAction}>
          {confirmLabel}
        </button>
        {displayButton && (
          <button className="pr-cancel" onClick={onClose}>
            Cancel
          </button>
        )}
      </div>
    </section>
  );
};
